<template>
  <option :value="value">{{ label }}</option>
</template>

<script>
export default {
  name: "SelectOption",
  props: ["label", "value"]
};
</script>

<style scoped></style>
